import Controller from '../abstracts/Controller';
import 'scss-templates/t-faqs.scss';

export default class FaqsController extends Controller {
  static get COMPONENTS() {
    return [
      'DropdownComponent',
    ];
  }

}
